import React, { useEffect, useState } from 'react';
import { Configuration, FrontendApi, LoginFlow, UiNode, UiNodeInputAttributes } from '@ory/client';
import { useSearchParams } from 'react-router-dom';
import { filterNodesByGroups, isUiNodeInputAttributes } from '@ory/integrations/ui';
import { Box, Center, Paper } from '@mantine/core';
import { LogoWithIcon } from 'src/UI/app-container/header/Header';
import Button from 'src/components/design-system/buttons/Button';

const ory = new FrontendApi(
  new Configuration({
    // In dev, use your Ory Tunnel URL, e.g. http://localhost:4000
    basePath: 'http://localhost:4000',
    baseOptions: {
      withCredentials: true, // important for cookies
    },
  }),
);
export const LoginPage = () => {
  const [flow, setFlow] = useState<LoginFlow>();
  const [searchParams] = useSearchParams();

  // Either get existing flow (?flow=) or create a new browser flow
  useEffect(() => {
    const flowId = searchParams.get('flow');
    if (flowId) {
      ory
        .getLoginFlow({ id: flowId })
        .then(({ data }) => setFlow(data))
        .catch(() => {
          // TODO
        });
      return;
    }

    ory
      .createBrowserLoginFlow()
      .then(({ data }) => setFlow(data))
      .catch(() => {
        // TODO
      });
  }, []);

  // Map a single UI node to an input or button
  const mapNode = (node: UiNode, idx: number) => {
    if (!isUiNodeInputAttributes(node.attributes)) return null;

    const attrs = node.attributes as UiNodeInputAttributes;
    if (attrs.type === 'submit' || attrs.type === 'button') {
      return (
        <Button
          key={idx}
          type={attrs.type as 'submit' | 'button'}
          name={attrs.name}
          disabled={attrs.disabled}
        >
          {node.meta?.label?.text ?? attrs.name}
        </Button>
      );
    }

    return (
      <div key={idx}>
        {node.meta?.label?.text && (
          <label>
            {node.meta.label.text}
            <input
              name={attrs.name}
              type={attrs.type}
              autoComplete={attrs.autocomplete || attrs.name === 'identifier' ? 'username' : ''}
              defaultValue={attrs.value}
              required={attrs.required}
              disabled={attrs.disabled}
            />
          </label>
        )}
        {!node.meta?.label?.text && (
          <input
            name={attrs.name}
            type={attrs.type}
            defaultValue={attrs.value}
            required={attrs.required}
            disabled={attrs.disabled}
          />
        )}
      </div>
    );
  };
  if (!flow) return <div>Loading login…</div>;

  return (
    <Box bg="gray.10" h="100vh">
      <Center h="100%">
        {!flow && <div>Loading login…</div>}
        {flow && (
          <Paper bg={'gray.0'} radius={'xl'} py={'48px'} px={'84px'}>
            <LogoWithIcon textColour={'gray.10'} />
            <form action={flow.ui.action} method={flow.ui.method}>
              {filterNodesByGroups({
                nodes: flow.ui.nodes,
                groups: ['default', 'password', 'identifier_first'],
              }).map((node, idx) => mapNode(node, idx))}
            </form>
          </Paper>
        )}
      </Center>
    </Box>
  );
};
